/* eslint-disable no-unused-vars */
import React, { memo, useState,useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Input,
  Card,
  Button,
  Col,
  Row,
  Form,
  Select,
  Modal,
  Upload
} from "antd";
import { useLocation, useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import messageToast from "../../../components/messageToast/messageToast";
import { PlusOutlined } from "@ant-design/icons";
import apis from "../../../api/stateAPI";
import { baseURL } from "../../../api/baseURL";
import { current } from "@reduxjs/toolkit";
import { MultiUploadButton } from "../../../components/multiUploadButton/MultiUploadButton";

const OrlpcclaimapparmForm = () => {
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [reason, setReason] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [selected, updateSelected] = useState([]);
  const [fileLists, setFileLists] = useState({});
  const [image, setImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const navigate = useNavigate();

  // Date Format Helper
  const dateToYMD = (date) => {
    const strArray = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const d = date.getDate();
    const m = strArray[date.getMonth()];
    const y = date.getFullYear();
    return `${d <= 9 ? "0" + d : d}-${m}-${y}`;
  };

  // Extract Data for Table
  const url = process.env.REACT_APP_API_BASE_URL.replace("api/", "");
  const data =
    state?.expense_data?.length > 0
      ? state.expense_data.map((e) => {
          // const unixtime = new Date(e.expense_date);
          // const time = dateToYMD(unixtime);
          const S_No = e.id;
          const Expense_Date = e.expense_date;
          const Expense_Type = e.expense_type;
          const Request_Amount = e?.amount;
          const Approved_Amount = e?.approved_amount;
          const Reason = e?.remark;
          // const bill_copy = e?.bill_copy
          //   ? JSON.parse(e?.bill_copy)
          //       ?.map(
          //         (item) => `${url}public/storage/app/public/tickets/${item}`
          //       )
          //       .join(", ")
          //   : "-";

          return {
            ...e,
            S_No,
            Expense_Date,
            Expense_Type,
            Request_Amount,
            Approved_Amount,
            Reason,
            //Bill_Copy: bill_copy
          };
        })
      : [];

  // Handle Table View Navigation
  const handleViewClick = (rowInfo) =>
    navigate("/orlpcclaimorlsubmissionForm", { state: rowInfo });

  // Handle Select All
  const SelectedAll = () => {
    if (state && state.expense_data) {
      updateSelected([...state.expense_data.map((_) => _.id)]);
    }
  };

  const currentDate = new Date().toISOString().split("T")[0]; 

  const handleSubmit = (datanew) => {  
    const expenseIds = state?.expense_data?.map((item) => item.id) || [];  
    const data = {    
      id: state?.id,
      expense_id: expenseIds,
      submission_date: currentDate,    
      bill_copy: image,
      status:
        state?.ticketstatus === "Waiting @ ARM"
          ? "Waiting @ Back Office"
          : "Waiting @ ARM"
    };     
    apis.updatePettyCashRequestData(data).then((res) => {
      if (res.data?.status === 200) {
        messageToast({
          message: res?.data?.statusText,
          status: res?.data?.status,
          title: "Payment Request"
        });
        navigate(
          state?.ticketstatus === "Waiting @ Back Office"
            ? "/orlpcclaimappbo"
            : "/orlpcclaimorlsubmission"
        );
      }
      else{
        messageToast({
          message: res?.data?.statusText,
          status: res?.data?.status,
          title: "ORL Pettycash Claim Submission"
        });        
      }
    });
  };

  // Handle Reject Action
 
  // Handle File Upload Change
  const handleChangenew = (info, rowKey) => {
    const { fileList } = info;
    setFileLists((prev) => ({ ...prev, [rowKey]: fileList }));   
    const imageUrl = info?.file?.response?.filename ?? "";  
    setImage((prev) => ({ ...prev, [rowKey]: imageUrl }));
    form.setFieldsValue({ [rowKey]: imageUrl });
  };

  const handlePreview = async (file) => {
    let src = file.url || file.preview;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(src);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const uploadButton = (
    <Button
      icon={<PlusOutlined />}
      style={{ display: "flex", flexDirection: "row" }}    
      className="orangeFactory"
      >
      <div style={{ marginLeft: "3px" }}>
        {state?.id ? "Upload" : "Upload"}
      </div>
    </Button>
  );

  // File Upload Props
  const props = {
    name: "image",
    action: `${baseURL}pettycash-orl-doc-submission`,
    headers: { authorization: "authorization-text" }
  };
  
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);


  // Columns for CustomTable
  const columns = [
    { key: "1", headerName: "S.No", field: "S.No", hide: false, width: 70 },
    {
      key: "2",
      headerName: "Expense Date",
      field: "Expense_Date",
      hide: false,
      width: 150
    },
    {
      key: "3",
      headerName: "Expense Type",
      field: "Expense_Type",
      hide: false,
      width: 230
    },
    {
      key: "4",
      headerName: "Reason",
      field: "Reason",
      hide: false,
      width: 350
    },
    {
      key: "5",
      headerName: "Request Amount",
      field: "Request_Amount",
      hide: false,
      width: 150
    },
    {
      key: "6",
      headerName: "Approved Amount",
      field: "Approved_Amount",
      hide: false,
      width: 150
    },
    {
      key: "7",
      headerName: "Bill Copy",
      field: "Bill_Copy",
      hide: false,
      width: 180,
      renderCell: (params) => {
        const rowKey = params.id;
        return (
          <>
            {" "}           
            <Upload
              {...props}
              style={{ width: "30px" }}
              fileList={fileLists[rowKey] || []}
              listType="picture-card"
              name="attachments" 
              onPreview={handlePreview}
              capture="environment"
              accept=".png,.jpg,.jpeg"
              onChange={(e) => handleChangenew(e, rowKey)}
              multiple
            >
              {fileLists[rowKey]?.length >= 1 ? null : uploadButton}
            </Upload>
            <Modal
              open={previewOpen}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
              width={modalWidth}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflow: "hidden",
                  cursor: dragging ? "grabbing" : "grab"
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
              >
                <img
                  src={previewImage}
                  alt="example"
                  style={{
                    width: "100%",
                    transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
                    transition: dragging ? "none" : "transform 0.3s ease"
                  }}
                />
              </div>
              <div style={{ marginTop: "10px", textAlign: "center" }}>
                <Button 
                    onClick={zoomIn} 
                    style={{ marginRight: "10px",backgroundColor: "#DAF7A6", color: "black" }}
                    className={`custom-background ${show ? "show" : ""}`}                                                 
                 >
                  Zoom In
                </Button>
                <Button 
                    onClick={zoomOut}
                    style={{ marginRight: "10px",backgroundColor: "#f0b27a", color: "black" }}
                    className={`custom-background ${show ? "show" : ""}`}>
                  Zoom Out
                </Button>
              </div>
            </Modal>
          </>
        );
      }
    }
  ];

  const [zoom, setZoom] = useState(1); // Initial zoom level
  const [position, setPosition] = useState({ x: 0, y: 0 }); // Track image position
  const [dragging, setDragging] = useState(false);
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

  // Zoom Functions
  const zoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3)); // Max 3x zoom
  const zoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 1)); // Min 1x zoom

  // Drag Handlers
  const handleMouseDown = (e) => {
    setDragging(true);
    setStartPosition({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleClickBack = () => {
    navigate("/orlpcclaimorlsubmission");
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - startPosition.x,
      y: e.clientY - startPosition.y
    });
  };

  const handleMouseUp = () => setDragging(false);

  const handleCancel = () => {
    setPreviewOpen(false);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const modalWidth = 430 * zoom;

  return (
    <>
      <div className="h-screen apphide lasthide">
        <Card>
          <Row>
            <Col span={24}>
              <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(values) => {}}
                form={form}
                autoComplete="off"
              >
                <Row gutter={[15, 0]}></Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <CustomTable
          showHeader={false}
          showEdit={false}
          dataSource={data}
          column={columns}
          hideActionBtn={true}
          handleViewClick={handleViewClick}
          title={"Approval List"}
        />
        {state?.ticketstatus !== "Waiting @ AH Approval" && (
          <Col
            span={12}
            style={{ textAlign: "center" }}
            className="d-flex align-items-center justify-content-end mt-3"
          >
            <Form.Item className="mx-2">
              <Button
                className={`custom-background ${show ? "show" : ""}`}
                style={{ backgroundColor: "#f5a60b", color: "black" }}
                htmlType="submit"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                  className={`custom-background ${show ? "show" : ""}`}
                  onClick={handleClickBack}
                  style={{ backgroundColor: "#6495ED", color: "black" }}
                  type="info"
                  htmlType="button"
              >
                  Back
              </Button>        
            </Form.Item>
          </Col>
        )}
      </div>
   
    </>
  );
};

export default memo(OrlpcclaimapparmForm);
